import _styled from '@emotion/styled/base';
import { useEffect } from 'react';
import { BsCardText } from '@react-icons/all-files/bs/BsCardText';
import { useContextSelector } from 'use-context-selector';
import { EditorPlaceholder } from '../../../components/EditorPlaceholder/EditorPlaceholder.js';
import { jsx } from '@emotion/react';
import '../../../contexts/internal/StickyContext.js';
import { EditorContext } from '../../../contexts/internal/EditorContext.js';
import 'lodash-es';
import '@bucketplace/ui';
import { useEditorNode } from '../../../hooks/useEditorNode.js';
import 'qs';
import 'query-string';
import '@bucketplace/bucket-log';
import { useTabContext } from '../Tab.js';

function TabContent(_ref) {
  var children = _ref.children,
    index = _ref.index,
    path = _ref.path;
  var _useTabContext = useTabContext(),
    currentIndex = _useTabContext.currentIndex;
  var isCurrentTab = index === currentIndex;
  useEditorInitializer({
    index: index,
    path: path
  });
  return jsx(Container, {
    isHidden: !isCurrentTab
  }, children || jsx(EditorPlaceholder, {
    icon: jsx(BsCardText, null),
    message: "\uC544\uC774\uD15C\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694."
  }));
}
function useEditorInitializer(_ref2) {
  var index = _ref2.index,
    path = _ref2.path;
  var isInEditor = !!useContextSelector(EditorContext, function (context) {
    return context;
  });
  var _useEditorNode = useEditorNode(path),
    isChildSelected = _useEditorNode.isChildSelected;
  var _useTabContext2 = useTabContext(),
    selectIndex = _useTabContext2.selectIndex;
  useEffect(function () {
    if (!isInEditor) {
      return;
    }
    if (!isChildSelected) {
      return;
    }
    selectIndex(index);
  }, [isChildSelected]);
}
var Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ez4hsh20"
} : {
  target: "ez4hsh20",
  label: "Container"
})(function (_ref3) {
  var isHidden = _ref3.isHidden;
  return isHidden && 'display: none;';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

export { TabContent };
//# sourceMappingURL=TabContent.js.map
